/*
公共方法
 */
let loading;

export function showLoading(text='请稍后...', lock=true) {
    loading = this.$loading({
        // target: el,
        lock: lock,
        text: text,
        background: 'rgba(0, 0, 0, 0.1)',
    })
}
export function hideLoading() {
    if(loading===undefined) return
    loading.close()
}
export function showMessage(text){
    this.$message({message: text, offset: window.screen.height / 2 - 100, duration: 2000})
}
export function showMessageWarning(text='fail~'){
    this.$message({message: text, type: 'warning', offset: window.screen.height / 2 - 100})
}
export function showMessageError(text='error~'){
    this.$message({message: text, type: 'error', offset: window.screen.height / 2 - 100})
}
export function showMessageSuccess(text='success!'){
    this.$message({message: text, type: 'success', offset: window.screen.height / 2 - 100})
}
export function showConfirm(text='确定？', resolve, reject){
    // let ctxe = null
    this.$confirm(text, '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, ctx, close)=>{
            if(action !== 'confirm'){
                close();             
                return
            }
            // ctxe = ctx
            ctx.confirmButtonLoading = true  //按钮显示加载
            if(resolve) resolve(close)
            // ctx.confirmButtonLoading = false;
            // close();
            // console.log(action, ctx, close)
        }
    })
    // .then((res)=>{
    //     if(resolve) resolve(res)
    // })
    .catch((res)=>{
        // ctxe.confirmButtonLoading = false;
        if(reject) reject(res)
    })
}

export const storage = {
    set(key, value){
        window.top.localStorage.setItem(key, JSON.stringify(value))
    },
    get(key){
        const value = window.top.localStorage.getItem(key)
        if(value && value !== undefined && value !== null){
            return JSON.parse(value)
        }
        return null
    },
    remove(key){
        window.top.localStorage.removeItem(key)
    }
}


export function toDecimal2(x){
    /**
     * 保留2位小数
     * @type {number}
     */
    var f = parseFloat(x);
    if(isNaN(f)) {
        return false;
    }
    f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}

export function backTop(){
    // document.getElementById('wrap').scrollTop = 0
    // let that = this
    let timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 2);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        // let osTop = that.$refs.wrap.scrollTop
    // that.$nextTick(() => {
    //     // that.$refs.wrap.scrollTop = 0
    //     that.$refs.wrap.scrollTo({
    //         top: 0,
    //         behavior: 'smooth',
    //     });
    // })
        if(osTop === 0){
            clearInterval(timer);
        }
    },30)
}
export function formatDate(date, type=1){
    date = new Date(date)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    if(type === 2)
        return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute].map(formatNumber).join(':')}`
        // return year + '-' + month + '-' + day + ' '+hour+':'+minute
    return `${[year, month, day].map(formatNumber).join('-')}`
    // return year + '-' + month + '-' + day
}
export function formatNumber(n){
    n = n.toString()
    return n[1] ? n : `0${n}`
}

export function transDate(date){
    try {
        // console.log('try')
        if(date && date !== 'null' && date !== '/'){
        // console.log(c.pouringStartDate.replace('\n', ' ').split(' '))
            date = date.replace('\n', ' ').replaceAll('/', '-').replaceAll('.', '-').split(' ')[0]
            let datasl = date.split('-')
            if(datasl.length>1){
                let month = parseInt(datasl[1])
                month = month < 10 ? '0' + month : month
                let day = parseInt(datasl[2])
                day = day < 10 ? '0' + day : day
                date = datasl[0] + '-' + month + '-' + day
                // console.log(date)
            }
        }
        else{
            date = ''      
            // console.log('else')
        }
    } catch (error) {
        date = ''
    }
    return date
}

// export function formatTime(timeStr, type){
//     var tsplist = timeStr.split('T')
//     var dates = tsplist[0]
//     var times = tsplist[1]
//     var year = dates.split('-')[0]
//     var month = dates.split('-')[1]
//     var day = dates.split('-')[2]
//     var hour = times.split(':')[0]
//     var min = times.split(':')[1]
//     //console.log(year)
//     if(type === 1)
//         return month + '-' + day + ' ' + hour + ':' + min
//     return year + '-' + month + '-' + day + ' ' + hour + ':' + min
// }

export function formatTime(date, type=1) {
    /**
     * 格式化日期
     */
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    if(type===0)
        return [year, month, day].map(formatNumber).join('-')  + ' ' + [hour, minute, second].map(formatNumber).join(':')
    else if(type===2)
        return [hour, minute].map(formatNumber).join(':')
    else if(type===3)
        return [hour, minute, second].map(formatNumber).join(':')
    else if(type===4)
        return year+'年'+month+'月'+day+'日'
    else
        return [year, month, day].map(formatNumber).join('-')
}

export function getDayOfWeek(date) {
  const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  return days[date.getDay()];
}

export function checkExistsList(val, array){
    /**
     * 验证值是否在list中
     */
    return array.indexOf(val) > -1
}